import AppStore from '../../stores/App';
import { actionGenerator } from '../../utils/Generator';

export default actionGenerator('AppAction', {
  async setStatus({ context, payload }) {
    const status = payload.getIn(['entity', 'status']).toJS();
    context.dispatch(AppStore.dispatchTypes.SET_STATUS, { status });
  },
});



// WEBPACK FOOTER //
// ./src/app/actions/App/App.js